import _ from "lodash";
import { Status } from "../../models/Status";
import { createAction } from "../../models/Action";
import { showMessageBox } from "../MessageBox/actions";
import { resetStatus } from "../SignUp/actions";
import history from "../../utils/history";
import * as T from "./types";
import { Auth } from "../../utils/auth";

export const gateKeeper = () => {
  return (dispatch, getState) => {
    const state = getState();
    const { user } = state.signUp;
    if (_.isEmpty(user) || user.userConfirmed) {
      dispatch(showMessageBox("We did not find an unconfirmed user"));
      history.replace("/");
    }
  };
};

export const confirmAccount = (username: string, values: any) => {
  return async (dispatch) => {
    try {
      dispatch(createAction(T.CONFIRM_ACCOUNT_STATUS, Status.createLoading()));
      await (await Auth()).confirmSignUp(username, values.code);
      dispatch(createAction(T.CONFIRM_ACCOUNT_STATUS, Status.createSuccess()));
      dispatch(resetStatus());
      dispatch(
        showMessageBox("Your account is activated now. Please login.", "info")
      );
      history.replace("/login");
    } catch (e: unknown) {
      const msg: string =
        e instanceof Error && !_.isEmpty(e.message) ? e.message : String(e);
      dispatch(showMessageBox(msg));
      dispatch(
        createAction(T.CONFIRM_ACCOUNT_STATUS, Status.createFailed(msg))
      );
    }
  };
};
